/**
 * @author Sasanka Weerakoon
 * @version 0.0.1
 * @since 21/4/2025
 */

import React, { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Select from "react-select";
import OrgsDropdown from "../../../components/orgsDropdown/OrgsDropdown";
import { Stack } from "@mui/material";
import api from "../../../../base/services/ResApi"
import Alerts from "../../../../base/errorHandeling/Alerts"
import { FormControl } from "@mui/material";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import GroupReportTable from "./GroupReportTable";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const GroupReport = () => {

    const selectOrgRef = useRef(null)

    const [orgCode, setOrgCode] = useState("");
    const [approvalStatus, setApprovalStatus] = useState("approved");
    const location = useLocation();
    const [filterData, setFilterData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false)
    const [successMessages, setSuccessMessages] = useState([])

    const [isError, setIsError] = useState(false)
    const [isErrorShow, setIsErrorShow] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])

    useEffect(() => {
        if (location.state?.orgCode) {
            setOrgCode(location.state.orgCode)
        }
    }, [location.state?.orgCode]);

    useEffect(() => {
        if (isError === true) {
            setTimeout(() => {
                setIsError(false)
                setErrorMessages([])
            }, 10000)
        }
    }, [isError])

    useEffect(() => {
        if (isSuccess === true) {
            setTimeout(() => {
                setIsSuccess(false)
                setSuccessMessages([])
            }, 3000)
        }
    }, [isSuccess])

    const handleChange = (event) => {
        const value = event?.target?.value;
        setOrgCode(value);
    };

    const approvalOptions = [
        { value: "approved", label: "Approved" },
        { value: "non-approved", label: "Non-Approved" },
    ];

    let approvedGroupConfig = {
        headers: {
            Action: approvalStatus === "approved" ? "V_ALL_APPR_GRP" : "V_ALL_NON_APPR_GRP",
            "Sort-Column": "grp_id",
            "Sort-Order": "desc",
            Filter: "F_ORG_CODE",
            Value: orgCode,
            "Is-Pagination": "false",
            "X-Additional-Info": true,
        },
    };

    const fetchGroupReportData = () => {
        if (!orgCode) return;

        setLoading(true);
        api
            .get("/groups", approvedGroupConfig)
            .then((res) => {
                setFilterData(res.data?.dataList);
                setLoading(false);
                setErrorMessages([]);
                setIsError(false);
            })
            .catch((error) => {
                setLoading(false);
                FetchErrorHandeling(
                    error,
                    setIsError,
                    setErrorMessages,
                    setIsErrorShow
                );
            });
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            padding: "10px",
        }),
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Stack className="report-filters" spacing={4} direction="row">
                <OrgsDropdown
                    orgCode={orgCode ? orgCode : ""}
                    onChange={handleChange}
                    selectRef={selectOrgRef}
                />
                <div>
                    <p
                        style={{
                            fontSize: "12px",
                            position: "relative",
                            top: "-9px",
                            left: "10px",
                            background: "#fff",
                            width: "200px",
                            paddingLeft: "5px",
                            zIndex: 99,
                        }}
                    >Approval status
                    </p>
                    <FormControl
                        required={false}
                        sx={{
                            minWidth: 400,
                            zIndex: 90,
                            position: "relative",
                            top: "-32px",
                            height: 0,
                        }}
                        size="medium"
                    >
                        <Select
                            options={approvalOptions}
                            value={approvalOptions.find((option) => option.value === approvalStatus)}
                            onChange={(selectedOption) =>
                                setApprovalStatus(selectedOption?.value || "approved")
                            }
                            isClearable
                            styles={{
                                ...customStyles,
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />

                    </FormControl>
                </div>
            </Stack>

            <Stack className="report-actions" spacing={2} direction="row" sx={{ my: 3 }}>
                <Button
                    color="warning"
                    variant="contained"
                    onClick={fetchGroupReportData}
                    disabled={!orgCode}
                    startIcon={<SearchIcon />}
                >
                    Search
                </Button>
                <Button
                    color="error"
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    onClick={() => {
                        setOrgCode("");
                        setApprovalStatus("approved");
                        setFilterData([]);
                        setErrorMessages([]);
                        setIsError(false);
                        setIsErrorShow(false);
                        selectOrgRef.current.clearValue();
                    }}
                >
                    Clear
                </Button>
            </Stack>

            <Alerts
                iserror={isError}
                errorMessages={errorMessages}
                isSuccess={isSuccess}
                successMessages={successMessages}
                iserrorShow={isErrorShow}
            />
            
            <GroupReportTable
                groupReportData={filterData}
                loading={loading}
            />
        </Box>
    )
}

export default GroupReport
